import React, { useState, useEffect } from 'react';
import { Container, Alert, Row, Col } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { apiUrl } from '../../util/Api';
import AccountUserList from './components/AccountUserList';
import AccountEditForm from './components/AccountEditForm';
import AccountInviteList from './components/AccountInviteList';
import ProviderKeyList from './components/ProviderKeyList';

//import {isAuthenticated} from '../../util/Auth';
import { useSelector } from 'react-redux';
import { getUserAccounts } from '../../app/slices/UserSlice';

const AccountDetail = () => {

  const [errors, setErrors] = useState([]);
  const [account, setAccount] = useState(null);
  const [showEditBtn, setShowEditBtn] = useState(false);
  //const [includeInvite, setIncludeInvite] = useState(false);
  const [includeProviderKeys, setIncludeProviderKeys] = useState(false);

  const [userCount, setUserCount] = useState(0);

  let navigate = useNavigate();

  let { accountKey } = useParams();

  let smWidth = 3;
  let mdWidth = 2;
  //let lgWidth = 6;

  //TODO: get users for the account
  //add buttons to edit account if role >= 2

  const currUserAccounts = useSelector(getUserAccounts);
  const currUserAccount = currUserAccounts.find(a => a.accountKey === accountKey);
  const currRoleId = currUserAccount ? currUserAccount.roleId : 0;

  

  useEffect(() => {
    //is an account selected?
    let options = {
      accountKey: accountKey
      //accountKey: 'accountKey'
    }
    let isAuthError = false;
    if (currRoleId > 1) {
      setShowEditBtn(true);
      //setIncludeInvite(true);
      setIncludeProviderKeys(true);
    }
    axios.post(apiUrl + '/accounts/detail',
      options, { withCredentials: true })
      .then((res) => {
        if (res.data.status === 'ok') {
          if (res.data.account !== null) {
            //console.log('account:', res.data.account)
            setAccount(res.data.account);
            setUserCount(res.data.account.usage.users);
            document.title = `reconify account: ${res.data.account?.account}`;
          }
          else {
            //need to show a message that account is missing?
            document.title = `reconify account not found`;
          }
        } else {
          let errorMsgs = [];
          let redirectToLogin = false;
          res.data.errors.forEach((error, i) => {
            switch (error) {
              case 'auth-expired':
              case 'auth-error':
                //console.log('auth expired');
                isAuthError = true;
                //navigate('/login');
                //errorMsgs.push('You have been logged out.');
                //return;
                redirectToLogin = true;
                break;
              case 'no-account':
              case 'no-valid-account':
                errorMsgs.push('The account could not be found.');
                break;
              case 'no-permissions':
                errorMsgs.push('You do not have permission to view this account.');
                break;
              default:
                errorMsgs.push('There was an error retrieving the account.');
            }
          });
          if (redirectToLogin) {
            navigate('/login');
            return;
          }
          //don't call setErrors if not logged in as it throws an unmounted error
          if (!isAuthError) {
            setErrors(errorMsgs);
          }
        }
      })
      .catch((err) => {

      });
  }, [accountKey, navigate, currRoleId]);

  return (
    <Container fluid>
      <div>
        <h3>Account</h3>
        {
          errors.length > 0 ? (
            <Alert variant='danger'>
              {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
            </Alert>
          ) : (null)
        }
        {

          account !== null ? (
            <Container>
              <Row className='my-2'>
                <Col className='detailLabel' sm={smWidth} md={mdWidth}>Account:</Col>
                <Col className='detailData'>{account.account}</Col>
              </Row>
              <Row className='my-2'>
                <Col className='detailLabel' sm={smWidth} md={mdWidth}>Timezone:</Col>
                <Col className='detailData'>{account.timezone}</Col>
              </Row>
              <Row className='my-2'>
                <Col className='detailLabel' sm={smWidth} md={mdWidth}>Your role:</Col>
                <Col className='detailData'>{account.role}</Col>
              </Row>
              {showEditBtn === true ? (
                <div>
                  <AccountEditForm updateAccount={setAccount} account={account} />
                  {/*<AccountEditForm accountKey={accountKey} account={account.account}/> */}
                </div>
              ) : null}
              {includeProviderKeys === true ? (
                <>
                <h4 className='mt-5'>Gen AI Provider API Keys</h4>
                <div className='chart-card'>
                  <ProviderKeyList />
                </div>
                </>
              )  : null}
              <h4 className='mt-5'>Members</h4>
              <div className='chart-card'>
                <AccountUserList updateUserCount={setUserCount}/>
              </div>
              <h4 className='mt-5'>Invites</h4>
              <div className='chart-card'>
                <AccountInviteList userCount={userCount}/>
              </div>
            </Container>
          ) : (null)
        }
      </div>


    </Container>
  )


}

export default AccountDetail;
